import React, { useState, useEffect } from "react";
import { END_POINT } from "../../constants/api.constants";
import {
  createOrderAPI,
  getAddressAPI,
  saveAddressAPI,
  saveCartItemsAPI,
} from "../../service/cart.service";
import CartTemplate from "./cart.template";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { productQtyChange } from "../../utils/search.utils";
import { clearCart, deleteCart, updateCart } from "../../reducers/cart.reducer";
import { formValidate } from "../../utils/validation.utils";
import { formatPrice, getCartTotal, getProductPrice } from "../../utils/cart.utils";
import { store } from "../../store";
import { checkPromoCodeAPI } from "../../service/common.service"

const validations = [
  {
    type: "REQUIRED",
    name: "company_name",
    message: "Company name required",
  },
  {
    type: "REQUIRED",
    name: "gstin_number",
    message: "GST Number required",
  },
  {
    type: "REQUIRED",
    name: "invoice_to",
    message: "Contact person required",
  },
  {
    type: "REQUIRED",
    name: "contact_person_number",
    message: "Contact person number required",
  },
  {
    type: "REQUIRED",
    name: "address_line1",
    message: "Address line 1 required",
  },
  {
    type: "REQUIRED",
    name: "address_line2",
    message: "Address line 2 required",
  },
  {
    type: "REQUIRED",
    name: "city",
    message: "City required",
  },
  {
    type: "REQUIRED",
    name: "state",
    message: "State required",
  },
  {
    type: "REQUIRED",
    name: "pincode",
    message: "Pincode required",
  },
];

const { DOWNLOAD_CART_ITEMS } = END_POINT;

const CartComponent = () => {
  const { cart } = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.app);
  const [deleteModal, setDeleteModal] = useState({ show: false });
  const [activeTab, setActiveTab] = useState("cart");
  const [address, setAddress] = useState({ billing: {}, shipping: [] });
  const [selectedShippingId, setSelectedShippingId] = useState(null);
  const [billingSame, setBillingSame] = useState(true);
  const [common, setCommon] = useState({ loading: false, data: true });
  const showCheckout = activeTab !== "cart";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // console.log({ cart });
  const [promoCode, setPromoCode] = useState("");
  const [showPromoInput, setShowPromoInput] = useState(false);
  const [promoCodeError, setPromoCodeError] = useState("");
  const [appliedPromo, setAppliedPromo] = useState(null);

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleQtyChange = (index, type, product) => {
    const updateProduct = productQtyChange(type, product);
    console.log({ updateProduct });
    dispatch(updateCart({ index, product: updateProduct }));
  };

  const handleManualQtyChange = ({ value, item, index }) => {
    const updateProduct = { ...item, required_qty: value };
    dispatch(updateCart({ index, product: updateProduct }));
  };

  const handleCartDelete = (index) => {
    console.log({ index });
    setDeleteModal({ ...deleteModal, show: !deleteModal.show, index: index });
  };

  const handleCartDeleteConfirm = () => {
    dispatch(deleteCart(deleteModal.index));
    setDeleteModal({ ...deleteModal, show: !deleteModal.show });
  };

  const handleNext = () => {
    if (activeTab === "address") setActiveTab("payment");
    else if (activeTab === "payment") setActiveTab("review");
  };

  const handleBack = () => {
    if (activeTab === "review") setActiveTab("payment");
    else if (activeTab === "payment") setActiveTab("address");
    else if (activeTab === "address") setActiveTab("cart");
  };

  const handleAddAddress = () => {
    navigate("/account", { state: { openTab: "addresses" } });
  };

  const handleEditAddress = () => {
    navigate("/account", { state: { openTab: "addresses" } });
  };

  console.log({ activeTab });

  const getAddressData = async () => {
    console.log("address data");
    setCommon({ ...common, loading: true });
    const resp = await getAddressAPI();
    console.log({ resp });

    if (resp.status) {
      const billing = resp.data.find((addr) => addr.type === "billing");
      const shipping = resp.data.filter((addr) => addr.type === "shipping");
      setAddress({ billing, shipping });

      console.log({ billing, shipping });

      if (shipping.length > 0 && shipping[0].same_shipping === 1)
        setBillingSame(true);
      else setBillingSame(false);

      setCommon({ ...common, loading: false });
    }
  };

  const handleShippingSelect = (id) => {
    setSelectedShippingId(id);
  };

  // Set the first address as default when addresses are loaded
  useEffect(() => {
    if (address?.shipping?.length > 0 && !selectedShippingId) {
      setSelectedShippingId(address.shipping[0].id);
    }
  }, [address?.shipping, selectedShippingId]);

  const handleProceedCheckout = async () => {
    if (!user) {
      handleLoginClick();
      return;
    }
    setActiveTab("address");
  };

  const handleContinuePayment = async () => {
    const validateBilling = formValidate({
      validations,
      values: address?.billing || {},
    });
    const validateShipping = formValidate({
      validations,
      values: address?.shipping || {},
    });

    if (billingSame && validateShipping.status > 0) {
      setAddress({ ...address, shippingErrors: validateShipping.errors });
      return;
    }

    if (
      !billingSame &&
      (validateShipping.status > 0 || validateBilling.status > 0)
    ) {
      setAddress({
        ...address,
        shippingErrors: validateShipping.errors,
        billingErrors: validateBilling.errors,
      });
      return;
    }

    setCommon({ ...common, loading: true });

    await saveAddressAPI({
      ...address,
      billing: billingSame ? address.shipping : address.billing,
      same_billing: billingSame,
    });

    setCommon({ ...common, loading: false });
    setActiveTab("payment");
  };

  // Call getAddressData when activeTab changes to address
  useEffect(() => {
    if (activeTab === "address") {
      getAddressData();
    }
  }, [activeTab]);

  const handleClickBillingAddressSameAsShipping = (e) => {
    console.log({ e: e.target.checked });
    setBillingSame(e.target.checked);
  };

  const handleChange = ({ type, name, value }) => {
    setAddress({ ...address, [type]: { ...address[type], [name]: value } });
  };

  const handlePayNow = async () => {
    setCommon({ ...common, loading: true });
    const { subTotal, total, gst } = getCartTotal(cart,appliedPromo);
    console.log("total",total);
  
    const cartData = cart?.map((item) => {
      const selected_price = getProductPrice(item);
      return {
        ...item,
        alternate_packaging: [],
        selected_price: selected_price,
        actual_price: selected_price,
        total_amount: selected_price * item.required_qty,
      };
    });

    const selectedShippingAddress = Array.isArray(address.shipping)
      ? address.shipping.find((addr) => addr.id === selectedShippingId)
      : address.shipping;

    const payload = {
      subTotal,
      total,
      gst,
      cart: cartData,
      type: 2,
      poDate: null,
      poNumber: null,
      ...address,
      shipping: selectedShippingAddress,
    };
    console.log({ payload });
    // return;

    const orderResp = await createOrderAPI(payload);

    console.log({ payload, orderResp });
    if (orderResp.status) {
      dispatch(clearCart([]));
      navigate("/order-status/" + orderResp.data.custom_order_id);
    }
  };

  const handleViewCartItems = () => {
    if (!user) {
      handleLoginClick();
      return;
    }
    navigate("/account?tab=saved-cart");
  };

  const saveCartItems = async () => {
    const cartData = cart?.map((item) => {
      const selected_price = getProductPrice(item);
      return {
        ...item,
        alternate_packaging: [],
        selected_price: selected_price,
        actual_price: selected_price,
        total_amount: selected_price * item.required_qty,
      };
    });

    const payload = {
      cart: cartData,
    };

    const saveResp = await saveCartItemsAPI(payload);

    return saveResp;
  };

  const handleSaveCartItems = async () => {
    if (!user) {
      handleLoginClick();
      return;
    }

    const saveResp = await saveCartItems();
    console.log({ saveResp });
    if (saveResp.status) {
      dispatch(clearCart([]));
      navigate("/account?tab=saved-cart");
    } else alert(saveResp.message);
  };

  const handleDownloadCartItems = async () => {
    if (!user) {
      handleLoginClick();
      return;
    }
    const saveResp = await saveCartItems();
    if (saveResp.status) {
      // const downloadResp = await downloadCartItemsAPI(saveResp.data.id);

      window.open(
        DOWNLOAD_CART_ITEMS +
          "?cart_id=" +
          saveResp.data.id +
          "&token=" +
          store.getState().app.token,
      );

      // console.log({ downloadResp });
    }
  };

const handleApplyPromoCode = async (code) => {
  setPromoCodeError("");
  if (!code.trim()) {
    setPromoCodeError("Please enter a promo code");
    return;
  }

  try {
    const response = await checkPromoCodeAPI({ code });
    if (response.status) {
      setAppliedPromo(response.data);
      setPromoCodeError(""); 
      return true;
    } else {
      setAppliedPromo(null);
      setPromoCodeError(response.message || "Invalid promo code");
      return false;
    }
  } catch (error) {
    console.error("Error applying promo code:", error);
    setAppliedPromo(null);
    setPromoCodeError("Failed to apply promo code. Please try again.");
    return false;
  }
};
  const templateData = {
    cart,
    user,
    address,
    deleteModal,
    activeTab,
    billingSame,
    common,
    showCheckout,
    selectedShippingId,
    promoCode,
    showPromoInput,
    promoCodeError,
    appliedPromo,
    };

  const templateEvent = {
    handleLoginClick,
    handleQtyChange,
    handleCartDelete,
    handleCartDeleteConfirm,
    handleManualQtyChange,
    handleProceedCheckout,
    handleContinuePayment,
    handleClickBillingAddressSameAsShipping,
    handleChange,
    handlePayNow,
    handleViewCartItems,
    handleSaveCartItems,
    handleDownloadCartItems,
    handleNext,
    handleBack,
    setActiveTab,
    handleAddAddress,
    handleEditAddress,
    handleShippingSelect,
    setSelectedShippingId,
    setPromoCode,
    setShowPromoInput,
    setAppliedPromo,
    handleApplyPromoCode,
  };

  return (
    <CartTemplate templateData={templateData} templateEvent={templateEvent} />
  );
};

export default CartComponent;
